module.exports = __webpack_public_path__ + "img/footer-facebook.ff72c536.svg";